module.exports = __webpack_public_path__ + "static/img/illust_mk_1.6059cfe7.svg";